module.exports = __webpack_public_path__ + "front/img/btn_2.7ec02709.jpg";